module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1044-d3d9a03448d3f4303d59c1d502652b8c.png";